// ============================================================================
// devopsRoles.ts — роли вертикали «Разработка» (SSoT имён — поставка
// hydra.devops, buildkit/devops.go). Используются для видимости приложения в
// доке/«Пуске» и для управления кнопками задач; серверные гейты
// (DevopsService) дублируют проверку — SSoT доступа.
// ============================================================================

import type { SecurityAccess } from '@/lib/securityRoles';

export const DEVOPS_MANAGE_ROLE = 'Разработка — управление';
export const DEVOPS_VIEW_ROLE = 'Разработка — просмотр';

/** Просмотр панели: админ ИЛИ любая роль вертикали. */
export function canViewDevops(access: SecurityAccess): boolean {
  return access.isAdmin
    || access.roles.includes(DEVOPS_MANAGE_ROLE)
    || access.roles.includes(DEVOPS_VIEW_ROLE);
}

/** Действия (запуск/остановка задач): админ ИЛИ роль «управление». */
export function canManageDevops(access: SecurityAccess): boolean {
  return access.isAdmin || access.roles.includes(DEVOPS_MANAGE_ROLE);
}
